
export enum ListeningApproach {
  Always,
  WhenReadOnly,
  Never,
}
